import React from 'react';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import { Controller } from 'react-hook-form';

const EnumSelect = React.forwardRef(({
  name,
  label,
  defaultValue = undefined,
  error,
  control,
  StatusEnum,
  rules,
  variant = "outlined",
  margin = "dense",
  disabled = false,
  onChange: onChangeFromParent,
  ...props
}, ref) => {

  const enumEntries = Object.entries(StatusEnum);

  return (
    <FormControl fullWidth size="small" variant={variant} margin={margin} error={!!error}>
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field }) => {
          // Normalize both to strings for comparison
          const valueExists = enumEntries.some(([value]) => String(value) === String(field.value));
          const selectedValue = valueExists ? field.value : ''; // Fallback to empty if value doesn't exist

          return (
            <Select
              {...field}
              ref={ref}
              value={selectedValue}
              labelId={`${name}-label`}
              label={label}
              disabled={disabled}
              onChange={(event) => {
                field.onChange(event.target.value);
                if (onChangeFromParent) {
                  onChangeFromParent(event.target.value);
                }
              }}
            >
              {enumEntries.map(([value, displayText]) => (
                <MenuItem key={value} value={value}>
                  {displayText}
                </MenuItem>
              ))}
            </Select>
          );
        }}
      />
      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
});

export default EnumSelect;
